import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";

import { studentActions } from "../_actions";
import { toast } from "react-toastify";

class StudentLogin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      number: "",
      birthDate: "",
      studentType: 1,
      password: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    localStorage.clear();
    $(document).ready(function () {
      $("#vmc-form-link").click(function (e) {
        $("#vmc-form").delay(100).fadeIn(100);
        $("#nonvmc-form").fadeOut(100);
        $("#nonvmc-form-link").removeClass("active");
        $('#non-vmc').addClass("non-vmc");
        $('#vmc').removeClass("vmc")
        $(this).addClass("active");
        e.preventDefault();
      });
      $("#nonvmc-form-link").click(function (e) {
        $("#nonvmc-form").delay(100).fadeIn(100);
        $("#vmc-form").fadeOut(100);
        $("#vmc-form-link").removeClass("active");
        $('#non-vmc').removeClass("non-vmc");
        $('#vmc').addClass("vmc")
        $(this).addClass("active");
        e.preventDefault();
      });
    });
  }

  handleChange(e) {
    if (document.getElementById("vmc-form-link").className === "active") {
      this.setState({
        studentType: 1,
      });
    } else {
      this.setState({
        studentType: 0,
      });
    }
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSignUp = () => {
    this.props.history.push('/signUp')
  }

  handleSubmit(e) {
    e.preventDefault();

    const { number, birthDate, studentType, password } = this.state;
    const { dispatch } = this.props;
    if (this.state.birthDate === "" || this.state.number === "" || this.state.password === "") {
      toast.error("Please fill the details");
    } else dispatch(studentActions.login(number, birthDate, studentType, password));

    // if (number && birthDate && studentType) {
    //   dispatch(studentActions.login(number && birthDate && studentType));
    // }
  }

  render() {
    const { number, birthDate, password} = this.state;
    return (
      <div>
        <div className="login-body">
          <div className="container ">
            <div className="logo" style={{ textAlign: "center" }}>
              <img
                src="https://www.vidyamandir.com/assets/images/vmc_logo.png"
                alt="VidyaMandir"
                style={{ marginTop: "3%", backgroundColor: "#1FB5AD" }}
              />
            </div>
            <div className="row">
              <div
                className="panel-heading"
                style={{
                  maxWidth: "330px",
                  height: "42px",
                  margin: "100px auto",
                  marginTop: "60px",
                  marginBottom: "-1px",
                  padding: '0'
                }}>
                <div style={{
                  height: "100%"
                }}>
                  <div style={{
                    height: "100%",
                    display: 'flex',
                    border: '2px solid darkgray',
                    borderBottom: 0

                  }}>
                    <div className="form-flex" id="vmc">
                      <a
                        className="active"
                        id="vmc-form-link"
                        style={{
                          display: "flex",
                          justifyContent: "center"
                        }}>
                        <strong>VMC Student</strong>
                      </a>
                    </div>
                    <div className="form-flex non-vmc" id="non-vmc"
                    >
                      <a id="nonvmc-form-link">
                        <strong>Non-VMC Student</strong>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <form
                className="form-signin"
                id="vmc-form"
                style={{ display: "block", marginTop: "0" }}
                onSubmit={this.handleSubmit}>
                <div>
                  <h2
                    className="form-signin-heading text-capital-none"
                    style={{ borderRadius: 0 }}>
                    VMC students need to enter their Roll no./Registration no. &amp; their DOB to login
                  </h2>
                </div>
                <div className="login-wrap">
                  <div className="user-login-info">
                    <input
                      type="text"
                      className="form-control fixed-height"
                      name="number"
                      placeholder="Enter Roll number"
                      value={number}
                      onChange={this.handleChange}
                    />
                    <input
                      type="date"
                      className="form-control fixed-height"
                      name="birthDate"
                      value={birthDate}
                      onChange={this.handleChange}
                    />
                    <input
                      type="password"
                      className="form-control fixed-height"
                      name="password"
                      placeholder="Enter Password"
                      value={password}
                      onChange={this.handleChange}
                    />
                  </div>
                  <Link to="/login/sendCode">Forgot password?</Link>
                  <button
                    type="submit"
                    className="btn btn-lg btn-login btn-block">
                    <strong>Sign in</strong>
                  </button>
                  <button
                    type="button"
                    onClick={this.handleSignUp}
                    className="btn btn-lg btn-login btn-block">
                    <strong>Sign Up</strong>
                  </button>
                </div>
              </form>
              <form
                className="form-signin"
                id="nonvmc-form"
                style={{ display: "none", marginTop: "0" }}
                onSubmit={this.handleSubmit}>
                <h2 className="form-signin-heading text-capital-none" style={{ borderRadius: 0 }}>
                  Non VMC students need to enter their Registration no. &amp; their DOB to login
                </h2>
                <div className="login-wrap">
                  <div className="user-login-info">
                    <input
                      type="text"
                      className="form-control fixed-height"
                      name="number"
                      placeholder="Enter Registration number"
                      value={number}
                      onChange={this.handleChange}
                    />
                    <input
                      type="date"
                      className="form-control fixed-height"
                      name="birthDate"
                      value={birthDate}
                      placeholder="Select Birth Date..."
                      onChange={this.handleChange}
                    />
                    <input
                      type="password"
                      className="form-control fixed-height"
                      name="password"
                      placeholder="Enter Password"
                      value={password}
                      onChange={this.handleChange}
                    />
                  </div>
                  <Link to="/login/sendCode">Forgot password?</Link>
                  <button
                    type="submit"
                    className="btn btn-lg btn-login btn-block">
                    <strong>Sign in</strong>
                  </button>
                  <button
                    type="button"
                    onClick={this.handleSignUp}
                    className="btn btn-lg btn-login btn-block">
                    <strong>Sign Up</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


      </div>
    );
  }
}

const connectedStudentLogin = connect()(StudentLogin);
export { connectedStudentLogin as StudentLogin };